import { useEffect, useState } from "react";

import {
  getThemeMode,
  resolveTheme,
  ResolvedTheme,
  setThemeMode,
  subscribeTheme,
  ThemeMode,
} from "./theme";

interface UseTheme {
  mode: ThemeMode;
  /** "system" seçiliyken cihazın o anki tercihi. */
  resolved: ResolvedTheme;
  setMode: (next: ThemeMode) => void;
}

/** Modül seviyesindeki tema durumuna abone olur, değişince yeniden render eder. */
export function useTheme(): UseTheme {
  /*
   * `mode` değil sayaç tutulur: sistem teması değişince `mode` yine "system" kalır ve
   * aynı değerle `setState` render'ı atlardı.
   */
  const [, bump] = useState(0);

  useEffect(() => subscribeTheme(() => bump((tick) => tick + 1)), []);

  const mode = getThemeMode();
  return { mode, resolved: resolveTheme(mode), setMode: setThemeMode };
}
